// generated by srcset-codegen
import src from "./tiktok.png";
import src2x from "./tiktok@2x.png";
import src3x from "./tiktok@3x.png";

const width = 17;
const height = 18;
const srcSet = `${src2x} 2x, ${src3x} 3x`;
export default { src, width, height, srcSet };
